import { ColDef } from '@ag-grid-community/core'
import { ValueGetterParams } from '@ag-grid-community/core/dist/cjs/entities/colDef'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { ITooltipParams } from '@ag-grid-community/core/dist/cjs/rendering/tooltipComponent'
import { generateMdiIcon } from '../utils/icon-utils'
import { heliosDefaultColWidth } from './default'
import { HsBooleanColDef } from './boolean'

export type UpdateStatus = 'FAILURE' | 'LOADING' | 'NONE' | 'SUCCESS'
/**
 *
 */
function isOfTypeUpdateStatus(value: string): value is UpdateStatus {
  return ['FAILURE', 'LOADING', 'NONE', 'SUCCESS'].includes(value)
}

/**
 *
 */
function filterValueGetter(params: ValueGetterParams) {
  const value = params.getValue(params.colDef.field ?? '')
  const status: UpdateStatus = value

  return status === 'SUCCESS' ? 'true' : 'false'
}

/**
 *
 */
function cellRenderer(params: ICellRendererParams) {
  switch (params.value) {
    case 'SUCCESS':
      return generateMdiIcon('mdi-pencil', ['text-orange'])
    case 'FAILURE':
      return generateMdiIcon('mdi-close-octagon', ['text-danger'])
    case 'LOADING':
      return `
              <div class="spinner-border spinner-border-sm d-flex" role="status">
  <span class="sr-only">Loading...</span>
</div>`
    case 'NONE':
    default:
      return ''
  }
}

/**
 *
 */
function valueGetter(params: ValueGetterParams) {
  const value = params.data.isEdited
  if (isOfTypeUpdateStatus(value)) return value

  if (value === true) return 'SUCCESS'

  return 'NONE'
}

/**
 *
 */
function tooltipValueGetter(params: ITooltipParams) {
  switch (params.value) {
    case 'SUCCESS':
      return 'Has been edited'
    case 'FAILURE':
      return 'Edit failed'
    case 'LOADING':
      return 'Edit processing'
    case 'NONE':
    default:
      return 'Has not been edited'
  }
}

export const HsBulkIsEditedColDef: ColDef = {
  ...HsBooleanColDef,
  width: heliosDefaultColWidth.SmallIcon,
  pinned: 'left',
  filterValueGetter,
  cellRenderer,
  valueGetter,
  tooltipValueGetter,
}
